import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/react-hooks';

import { Stage, TeaserContainer, JobTeaser, Container } from '@ccg/fork';

import relatedJobsQuery from '../../../graphql/queries/relatedJobs.graphql';

import Embeds from '../../shared/Embeds/Embeds';

import PageTemplate from '../templates/page';

const JobTemplate = ({ data, site }) => {
  if (!data.entry) return null;

  const { title, subline, embeds, embedsCopy, locations, companies } = data.entry;
  const { relatedJobsCount } = data.teaserSettings;

  const limit = relatedJobsCount || 4;

  const { data: relatedData } = useQuery(relatedJobsQuery, {
    variables: {
      site,
      currentId: data.entry.id,
      limit,
      relatedTo: [...locations, ...companies].map(item => parseFloat(item.id))
    }
  });

  const relatedEntries = relatedData && relatedData.relatedEntries;

  return (
    <PageTemplate
      seo={data.entry}
      seoDefaults={data.seoDefaults}
      navigation={data.navigation}
      footer={data.footer}
      cookieLayer={data.cookieLayer}
    >
      <Stage
        headline={title}
        subline={subline}
        breadcrumbLink={{
          label: 'Jobs',
          href: { pathname: '/standard', query: { uri: 'jobs' } },
          asPath: '/jobs'
        }}
      />

      <Embeds embedsCopy={embedsCopy} embeds={embeds} />

      {relatedEntries && relatedEntries.length > 0 && (
        <Container headline="Similar jobs:">
          <TeaserContainer>
            {relatedEntries &&
              relatedEntries.map(item => (
                <JobTeaser
                  key={item.id}
                  title={item.title}
                  locations={item.locations}
                  link={{
                    href: { pathname: '/job', query: { slug: item.slug } },
                    asPath: `/${item.uri}`
                  }}
                />
              ))}
          </TeaserContainer>
        </Container>
      )}
    </PageTemplate>
  );
};

JobTemplate.propTypes = {
  site: PropTypes.string.isRequired,
  data: PropTypes.shape().isRequired
};

JobTemplate.defaultProps = {};

export default JobTemplate;
